import React from 'react';
import { PlusIcon } from '../../../appearence/icons/plus_icon';
import { useTranslation } from 'react-i18next';
import { popupOpenService } from '../../../services/popupOpenService';
import { POPUP_KEY_ADD_PROPERTY, SMALL_WEB_SCREEN_WIDTH } from '../../../constant';
import { propertiesStorage } from '../../../services/propertiesStorage';
import { Button } from '@chapche/ui';

const AddNewPropertyButton = () => {
    const { i18n } = useTranslation();
    const openAddPropertyPopup = () => {
        propertiesStorage.loadItems(() => popupOpenService.callToOpen(POPUP_KEY_ADD_PROPERTY), SMALL_WEB_SCREEN_WIDTH + 1, '?valid=true');
    };

    return (
        <Button variant="outline" className="product__tab-button" onClick={openAddPropertyPopup}>
            {i18n.t('app.page.product.productFormTab.addProperty')}
            <PlusIcon nameOfClass="product__add-plus ml-8" handleClick={() => null} />
        </Button>
    );
};

export default AddNewPropertyButton;
